var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "currentColor",
    viewBox: "0 0 37 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.77 17a.997.997 0 0 0-.98 1.195A1 1 0 1 0 14.77 17m3.994 0a.997.997 0 0 0-.98 1.195 1 1 0 1 0 .98-1.195m3.994 0a.997.997 0 0 0-.979 1.195 1 1 0 0 0 1.362.728.999.999 0 0 0-.383-1.923m-3.994-9a9.98 9.98 0 0 0-7.061 2.929 10 10 0 0 0-2.925 7.07 9.9 9.9 0 0 0 2.257 6.33l-1.997 2a1 1 0 0 0-.21 1.09 1 1 0 0 0 .949.58h8.987a9.98 9.98 0 0 0 7.061-2.929 10.007 10.007 0 0 0 0-14.141A9.98 9.98 0 0 0 18.765 8m0 18h-6.58l.928-.93a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.7 8.004 8.004 0 0 1 3.322-13.314 7.98 7.98 0 0 1 5.376.26 8 8 0 0 1 3.99 3.618 8.01 8.01 0 0 1-1.97 9.956A7.98 7.98 0 0 1 18.765 26"
  })));
};
export default SvgChat;